import { registerWebModule, NativeModule } from "expo";

class LegacyKitModule extends NativeModule {
  async presentLegacyApp(): Promise<void> {
    throw new Error("Legacy app is not supported on web");
  }

  async dismissLegacyApp(): Promise<void> {
    // No-op on web - legacy app is iOS/Android only
  }

  configure(config: { apiBaseUrl: string }): void {
    // No-op on web - legacy app is iOS/Android only
  }

  onAppDidBecomeActive(): void {
    // No-op on web
  }

  onAppWillEnterForeground(): void {
    // No-op on web
  }

  onAppDidEnterBackground(): void {
    // No-op on web
  }

  setCredentials(userId: string, token: string, email: string): void {
    // No-op on web - credentials are handled differently
    console.log("[LegacyKit Web] setCredentials called - no-op on web");
  }
}

export default registerWebModule(LegacyKitModule, "LegacyKitModule");
